import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { articles } from '@/mocks/articles';

export default function FeaturedDigest() {
  const [lead, ...rest] = articles.slice(0, 4);

  return (
    <section id="featured" className="w-full bg-secondary-950">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <SectionHeading
          eyebrow="深度盘点"
          title="不止是标题，值得读完的那几件"
          description="把今天讨论度高的几个话题做成一页能读完的盘点，交代来龙去脉，也把不同声音摆出来。"
          extra={
            <Link
              to="/ranking"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-accent-400/70 text-sm text-accent-300 hover:bg-accent-500 hover:text-foreground-950 hover:border-accent-500 transition-colors whitespace-nowrap"
            >
              全部盘点
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          }
        />

        <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr] gap-6">
          <article className="group relative rounded-lg overflow-hidden bg-foreground-900 min-h-[320px] md:min-h-[420px]">
            <Link to={`/article/${lead.id}`} className="block absolute inset-0" aria-label={lead.title}>
              <img
                src={lead.cover}
                alt={`${lead.title} 深度盘点配图`}
                title={`${lead.title} · 黑料今日深度盘点`}
                className="w-full h-full object-cover object-top opacity-70 group-hover:opacity-80 group-hover:scale-105 transition-all duration-700"
              />
              <span className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/50 to-transparent"></span>
            </Link>
            <div className="relative p-6 md:p-8 flex flex-col justify-end h-full min-h-[320px] md:min-h-[420px] pointer-events-none">
              <span className="inline-flex w-fit items-center gap-2 px-2.5 py-1 rounded bg-primary-500 text-background-50 text-xs mb-4">
                <i className="ri-star-smile-fill" aria-hidden="true"></i>
                今日主编推荐
              </span>
              <h3 className="font-heading text-xl md:text-3xl font-bold text-background-50 leading-snug max-w-2xl">
                <Link to={`/article/${lead.id}`} className="pointer-events-auto">
                  {lead.title}
                </Link>
              </h3>
              <p className="mt-3 text-sm text-background-100/80 leading-7 max-w-xl line-clamp-2">{lead.summary}</p>
              <div className="mt-5 flex items-center gap-4 text-xs text-background-100/60">
                <span>{lead.category}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line text-accent-400" aria-hidden="true"></i>
                  {lead.heat.toLocaleString()}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  {lead.readMinutes} 分钟读完
                </span>
              </div>
            </div>
          </article>

          <div className="flex flex-col gap-4">
            {rest.map((article) => (
              <article
                key={article.id}
                className="group flex gap-4 bg-secondary-900/60 border border-secondary-800 rounded-lg p-4 hover:border-accent-400/60 transition-colors"
              >
                <Link to={`/article/${article.id}`} className="shrink-0 w-24 h-24 md:w-28 md:h-28 rounded-md overflow-hidden bg-secondary-800">
                  <img
                    src={article.cover}
                    alt={`${article.title} 盘点缩略图`}
                    title={`${article.title} · 黑料今日热点盘点`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </Link>
                <div className="flex flex-col justify-center min-w-0">
                  <span className="text-xs text-accent-400 mb-1">{article.category}</span>
                  <h3 className="font-heading text-base font-bold text-background-50 leading-6 line-clamp-2 group-hover:text-accent-300 transition-colors">
                    <Link to={`/article/${article.id}`}>{article.title}</Link>
                  </h3>
                  <span className="mt-2 text-xs text-secondary-300/80 flex items-center gap-3">
                    <span>{article.author}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line" aria-hidden="true"></i>
                      {article.heat.toLocaleString()}
                    </span>
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}